import { ajax } from '../ajax'


//、 授课-课中获取小组信息
export const reqSKGroupList = (paramets) => ajax(`/jxclass/jxClassGroup/listGroupScore`, paramets)

//、 授课-课中获取小组中学生信息
export const reqSKGroupStuList = (paramets) => ajax(`/jxclass/jxClassStudent/getStuListByGroupId`, paramets)

//、 授课-课中得分增加
export const reqSKScoreStu = (paramets) => ajax(`/jxclassroom/jxScoreStuRecord/add`, paramets, 'post')

//、 授课-课中获取评分选项列表
export const reqSKOptList = (paramets) => ajax(`/jxclassroom/jxScoreStuRecord/getScore`, paramets,)

//、 授课-课中获取全班中学生信息
export const reqSKClassStuList = (paramets) => ajax(`/jxclass/jxClassStudent/queryList`, paramets)

//、 授课-课中获取课程目录列表
export const reqSKCatalogList = (paramets) => ajax(`/jxcourse/jxCourseCatalog/getCatalogByClassStu`, paramets)

//、 授课-课中活动记录
export const reqSKActivityRecordAdd = (paramets) => ajax(`/jxclassroom/jxActivityRecord/add`, paramets,'post')



// WEBPACK FOOTER //
// ./src/api/give-course/other.js